/*
 * @Author: codesides
 * @Descripttion:
 * @Date: 2022-06-16 14:33:38
 * @LastEditors: codesides
 * @LastEditTime: 2026-03-18 11:08:46
 * @FilePath: \lesson-web-cms\src\utils\tools.ts
 */

import store from '@/store'
import { hr } from 'element-plus/es/locale'
import { message } from 'ant-design-vue'

/**
 * 数据脱敏处理
 * @param {String} value 原始数据
 * @param {'phone' | 'idCard'} type 脱敏类型
 * @returns {String} 脱敏后数据
 */
export const desensitize = (value, type) => {
  if (!value) return ''

  switch(type) {
    case "name":
      // 姓名脱敏
      if (value.length >= 3) {
        return (
          value.substring(0, 1) +
          "*".repeat(value.length - 2) +
          value.substring(value.length - 1)
        );
      } else {
        return value.substring(0, 1) + "*".repeat(value.length - 1);
      }

    case "password":
      return "*".repeat(value.length);

    case 'phone':
      // 手机号：前3后4
      if (value.length === 11) {
        return value.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      }
      // 非11位手机号，简单处理
      return value.length > 7
        ? value.substring(0, 3) + "****" + value.substring(value.length - 4)
        : value;

    case 'idCard':
      // 身份证：前6后4
      if (value.length < 8) return value;
      return (
        value.substring(0, 6) +
        "*".repeat(value.length - 10) +
        value.substring(value.length - 4)
      );

    default:
      return value
  }
}

export function isIE() {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) return true
  else return false
}

export function isEdge() {
  return navigator.userAgent.indexOf('Edge') > -1
}
// 防抖函数
export const debounce = (
  func, // 执行事件
  waitTime = 1000, // 执行间隔时间
  immediate = true // 是否立即执行
) => {
  let timer = null;
  return function (...args) {
    const callNow = Boolean(immediate && !timer);
    // console.log(timer, callNow);
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      if (!immediate) func.apply(this, args);
    }, waitTime);
    console.log(timer, callNow, immediate);
    if (callNow) func.apply(this, args);
  };
};

/**
 * 下载地址
 * @param {String} url
 */

export const downloadFile = (url: any, fileName = '下载', blob = false) => {
  const link = document.createElement('a')
  link.style.display = 'none'
  if (blob) {
    link.href = window.URL.createObjectURL(url)
  } else {
    link.href = url
  }
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  //释放内存
  window.URL.revokeObjectURL(link.href)
}

/**
 *
 * @param {string} fileName 文件名
 * @param {blob} blob blob文件
 */
export function exportFile(fileName: string, blob: any) {
  if (!blob) return
  if (isIE() || isEdge()) {
    ;(window as any).navigator.msSaveOrOpenBlob(blob, fileName)
  } else {
    const binaryData = []
    binaryData.push(blob)
    const url = window.URL || window.webkitURL || (window as any).moxURL
    const downloadHref = url.createObjectURL(new Blob(binaryData))
    const downloadLink = document.createElement('a')
    downloadLink.href = downloadHref
    downloadLink.download = fileName
    downloadLink.click()
  }
}

export function downloadHref(fileName: string, url: string) {
  const downloadLink = document.createElement('a')
  downloadLink.href = url
  downloadLink.download = fileName
  downloadLink.click()
}

/**
 * 文件大小 字节转换单位
 * @param size
 * @returns {string|*}
 */
export const filterSize = (size: number) => {
  if (!size) return ''
  if (size < pow1024(1)) return size + ' B'
  if (size < pow1024(2)) return (size / pow1024(1)).toFixed(2) + ' KB'
  if (size < pow1024(3)) return (size / pow1024(2)).toFixed(2) + ' MB'
  if (size < pow1024(4)) return (size / pow1024(3)).toFixed(2) + ' GB'
  return (size / pow1024(4)).toFixed(2) + ' TB'
}

// 求次幂
function pow1024(num: number) {
  return Math.pow(1024, num)
}

export function transformFormat(format: string) {
  switch (format && format.toLowerCase()) {
    case 'm3u':
    case 'mp3':
    case 'wav':
      return 'audio'
    case 'xla':
    case 'xlc':
    case 'xlm':
    case 'xls':
    case 'xlsx':
    case 'xlt':
    case 'xlw':
      return 'excel'
    case 'pot':
    case 'pps':
    case 'ppt':
    case 'pptx':
      return 'ppt'
    case 'pdf':
      return 'pdf'
    case 'gif':
    case 'jpeg':
    case 'jpg':
    case 'svg':
    case 'ico':
    case 'rgb':
    case 'png':
      return 'pic'
    case 'css':
    case 'html':
    case 'txt':
    case 'rtx':
      return 'txt'
    case 'mp2':
    case 'mov':
    case 'avi':
    case 'mp4':
    case 'wmv':
      return 'video'
    case 'doc':
    case 'docx':
    case 'dot':
      return 'word'
    case 'zip':
    case 'rar':
      return 'zip'
    default:
      return 'else'
  }
}

/*
 *   timestamp 当前时间戳，毫秒
 *   formats 时间格式，包括：
 *               1. Y-m-d
 *               2. Y-m-d H:i:s
 *               3. Y年m月d日
 *               4. Y年m月d日 H时i分s秒
 */

export function dateFormat(timestamp?: string, formats?: string) {
  formats = formats || 'Y-m-d'
  const zero = function (value: number) {
    if (value < 10) {
      return '0' + value
    }
    return value
  }
  const myDate = timestamp ? new Date(+timestamp) : new Date()
  const year = myDate.getFullYear()
  const month = zero(myDate.getMonth() + 1)
  const day = zero(myDate.getDate())
  const hour = zero(myDate.getHours())
  const minite = zero(myDate.getMinutes())
  const second = zero(myDate.getSeconds())

  return formats.replace(/Y|m|d|H|i|s/gi, function (matches): any {
    return {
      Y: year,
      m: month,
      d: day,
      H: hour,
      i: minite,
      s: second,
    }[matches]
  })
}

// 所属分类的格式化 传入一级分类
interface selectType {
  value: string
  label: string
  children: { value: string; label: string }[]
}
export function typeSelectOptionsFormate(list: any) {
  const _list: selectType[] = []
  if (list.length === 0) {
    return []
  } else {
    list.forEach((e1: any) => {
      const obj1: selectType = {
        value: '',
        label: '',
        children: [],
      }
      obj1.value = e1.firstLevelCategoryId
      obj1.label = e1.firstLevelCategoryName
      if (e1.secondLevels?.length > 0) {
        e1.secondLevels.forEach((e2: any) => {
          const obj2: selectType = {
            value: '',
            label: '',
            children: [],
          }
          obj2.value = e2.secondLevelCategoryId
          obj2.label = e2.secondLevelCategoryName
          if (e2.thirdLevels?.length > 0) {
            e2.thirdLevels.forEach((e3: any) => {
              const obj3: { value: string; label: string } = {
                value: '',
                label: '',
              }
              obj3.value = e3.thirdLevelCategoryId
              obj3.label = e3.thirdLevelCategoryName
              obj2.children.push(obj3)
            })
            obj1.children.push(obj2)
          } else {
            obj2.children = []
          }
        })
      } else {
        obj1.children = []
      }
      _list.push(obj1)
    })
  }
  // console.log(_list)
  return _list
}

export const navigateto = (url: string, type = '_self', to = 1) => {
  if (store.state.domains) {
    const { lessonDomain, toLoginUrl } = store.state.domains as any

    let hrefUrl = ''
    switch (to) {
      case 1:
        hrefUrl = `${lessonDomain}${url}`
        break
      case 2:
        hrefUrl = `${toLoginUrl}`
        break
      default:
        break
    }
    window.open(hrefUrl, type)
  }
}

export const logout = () => {
  navigateto('/logout.do')
}

export const toLogin = () => {
  navigateto('', '_self', 2)
}

export const judgeBtnRole = (roleJudge: string | string[]) => {
  const permissions: string[] = store.state.permission.permissions || []
  if (Array.isArray(roleJudge)) {
    return roleJudge.some((rs) => permissions.includes(rs))
  } else {
    return permissions.includes(roleJudge)
  }
}
/**
 *  转base64
 * @param file
 * @returns
 */
export function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
/**
 *  http请求 query对象转字符串
 * @param query
 */
export function queryToStr(query: object) {
  const queryArr = []
  for (const key in query) {
    queryArr.push(`${key}=${query[key]}`)
  }
  const queryStr = queryArr.length ? '?' + queryArr.join('&') : ''
  return queryStr
}
/**
 *  视频时长转换字符串
 * @param time
 * @param formats
 * @returns
 */
export function videoTimeFormat(time: number, formats = 'HH:mm:ss') {
  const hour = Math.floor(time / 3600)
    .toString()
    .padStart(2, '0')
  const minite = Math.floor((time % 3600) / 60)
    .toString()
    .padStart(2, '0')
  const second = Math.floor(time % 60)
    .toString()
    .padStart(2, '0')
  return formats.replace(/HH|mm|ss|H|m|s/gi, function (matches): any {
    return {
      H: hour,
      HH: hour,
      m: minite,
      mm: minite,
      s: second,
      ss: second,
    }[matches]
  })
}
export const getFileType = (fileType: string, isLink: string | number) => {
  if (isLink === 'YES' || isLink === 1) {
    return 'attach'
  } else {
    // console.log('fileType', fileType);
    fileType = fileType && fileType.toLowerCase()
    const videos = [
      // 视频
      'mp4',
      'wmv',
      'asf',
      'asx',
      'mpg',
      'mpeg',
      'mpe',
      'rm',
      'rmvb',
      '3gp',
      'mov',
      'm4v',
      'avi',
      'dat',
      'mkv',
      'flv',
      'vob',
      // 音频
      'mp3',
      'wav',
      'wma',
      'mp2',
      'flac',
      'midi',
      'ra',
      'ape',
      'aac',
      'cda',
    ]
    const imgs = [
      'jpeg',
      'dds',
      'psd',
      'pdt',
      'webp',
      'xmp',
      'gif',
      'bmp',
      'svg',
      'tiff',
      'jpg',
      'png',
    ]
    const docs = ['doc', 'docx', 'pdf', 'pdfx']
    const downs = ['xlsx', 'xls', 'txt']
    const ppts = ['ppt', 'pptx']
    if (videos.some((vs) => vs === fileType)) {
      return 'video'
    }
    if (imgs.some((is) => is === fileType)) {
      return 'img'
    }
    if (docs.some((is) => is === fileType)) {
      return 'doc'
    }
    if (ppts.some((is) => is === fileType)) {
      return 'ppt'
    }
    if (downs.some((is) => is === fileType)) {
      return 'down'
    }
    return fileType
  }
}

// 加载动画
export let loadingMessageFn: any = null
export const showLoading = (msg = '请稍候...') => {
  if (loadingMessageFn) return
  loadingMessageFn = message.loading({ content: msg, duration: 0 })
}
export const hideLoading = () => {
  if (!loadingMessageFn) return
  loadingMessageFn()
  setTimeout(() => {
    loadingMessageFn = null
    message.destroy()
  }, 1500)
}
